<template lang="pug">
product-desktop(v-if="q.platform.is.desktop && product")
product-mobile(v-if="q.platform.is.mobile && product")
</template>

<script>
import { cityIn } from 'lvovich';
import { LoadingBar, useMeta, useQuasar } from 'quasar';
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { getValid_In } from 'assets/helpers/blackListCitys';

import ProductMobile from './ProductMobile.vue';
import ProductDesktop from './ProductDesktop.vue';

export default {
    name: 'Product',
    components: {
        ProductMobile,
        ProductDesktop,
    },
    async preFetch({ store, currentRoute, previousRoute, ssrContext, redirect }) {

        if (currentRoute.params.productId !== previousRoute?.params.productId) {
            LoadingBar.setDefaults({
                color: 'positive',
                size: '4px',
                position: 'top',
            });
            LoadingBar.start();

            const authhorized = store.getters['user/USER_AUTHORIZED'];

            let routeCity = null;


            const response = await store.dispatch('cityForm/GET_LOCATIONS');
            response.results.forEach((region) => {
                region.cities.find((item) => {
                    if (item.slug === currentRoute.params.city) {
                        routeCity = item;
                    }
                });
            });


            const slug = currentRoute.params.productId;

            if (currentRoute.meta.product) {
                store.commit('products/SET_PRODUCT', currentRoute.meta.product);
            } else {
                try {
                    if (!authhorized && routeCity?.id) {
                        await store.dispatch('products/GET_PRODUCT_BY_SLUG', {
                            id: slug,
                            city_id: routeCity.id,
                        });
                    } else {
                        await store.dispatch('products/GET_PRODUCT_BY_SLUG', { id: slug });
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        return Promise.reject({ code: 404 });
                    }
                }

            }

            const result = store.getters['products/PRODUCT'];

            if (result && result.oldUrl && result.oldUrl.includes(currentRoute.params.productId)) {
                redirect({ path: result.url }, 301);
            }

            // Редирект на /catalog от СЕО

            if (currentRoute.path.includes('catalog')) {
                redirect({ path: currentRoute.path.replace('/catalog', '') }, 301);
            }
            if (currentRoute.path.includes('product/product')) {
                redirect({ path: currentRoute.path.replace('/product/product', '/product') }, 301);
            }
            if (currentRoute.path.includes('undefined/product')) {
                redirect({ path: currentRoute.path.replace('/undefined/product', '/product') }, 301);
            }

            //store.commit('products/SET_PRODUCT', result);

            // if(authhorized)
            //     await store.dispatch('advertisement/GET_HISTORY');

            LoadingBar.stop();
        }
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        const userCityId = computed(() => store.getters['user/USER_CITY_ID']);
        const product = computed(() => store.getters['products/PRODUCT']);
        const productPriceMeta = computed(() => {
            if (product.value.price) {
                return ' по цене ' + product.value.price + ' руб.';
            } else return '';
        });
        const productPrice = computed(() => {
            if (product.value.price) {
                return ', цена ' + product.value.price + ' руб.';
            } else return '';
        });
        const schemaPrice = computed(() => {
            if (product.value.price) {
                return `"price": "${product.value.price}",`;
            } else return '';
        });


        const city = computed(() => product.value?.inventoryList[0]?.geo?.cityName);

        const metaCity = computed(() => {
            return getValid_In(city.value);
        });

        const productName = computed(() => product.value ? product.value.name.replaceAll('"', '') : '');
        const productSubtitleFull = computed(() => product.value ? product.value.subtitleFull.replaceAll('"', '') : '');
        const productSubtitleShort = computed(() => product.value ? product.value.subtitleShort.replaceAll('"', '') : '');
        const productManufacturer = computed(() => product.value ? product.value.manufacture.replaceAll('"', '') : '');
        const productBarcode = computed(() => {
            if (product.value) {
                if (product.value.barcode.length) {
                    return product.value.barcode[0];
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        });

        const seoTitle = computed(() => product.value ? product.value.seoTitle?.replace('{}', metaCity.value) : '');
        const seoDescription = computed(() => product.value ? product.value.seoDescription?.replace('{}', metaCity.value) : '');
        const seoKeywords = computed(() => product.value ? product.value.seoKeywords : '');

        const metaTitle = computed(() => {
            if (product.value) {
                const country = product.value.country ? product.value.country : '';
                return seoTitle.value || productName.value + ' ' + productSubtitleFull.value + ' ' + productManufacturer.value + ' ' + country + ': ' + 'купить в ' + metaCity.value + productPriceMeta.value + '| Интернет-аптека eTabl.ru (партнер Таблеточка)';
            } else {
                return '';
            }
        });
        const metaDescription = computed(() => {
            if (product.value) {
                const country = product.value.country ? product.value.country : '';
                return seoDescription.value || productName.value + ' ' + productSubtitleFull.value + ' ' + productManufacturer.value + ' ' + country + ': ' + 'купить в ' + metaCity.value + productPriceMeta.value + ' с доставкой на дом 🚛 на сайте онлайн-аптеки eTabl.ru (партнер Таблеточка) ✔ Инструкция по применению, отзывы ✔ Гарантия качества ✔ ☎ 8 (800) 200-5-400';
            } else {
                return '';
            }
        });
        const metaKeywords = computed(() => {
            if (product.value) {
                const country = product.value.country ? product.value.country : '';
                return seoKeywords.value || productName.value + ' ' + productSubtitleFull.value + ' ' + productManufacturer.value + ' ' + country + ' ' + ' купить' + productPrice.value;
            } else {
                return '';
            }
        });
        const productRating = computed(() => {
            let rating = 0;

            product.value.reviews.forEach((item) => rating += item.rating);

            return (rating / product.value.reviews.length).toFixed(1);
        });
        let MedicalGuideline = computed(() => {
            let desc = '';
            if (product.value?.description) {
                product.value?.description.forEach((item) => {
                    if (item.title === 'Показания к применению') {
                        desc = item.value;
                    }
                });
            }
            return desc;
        });

        watch(product, () => {
            if (process.env.CLIENT) {
                // window._paq.push(['trackGoal', 1, `${productName.value} ${productSubtitleFull.value} ${productManufacturer.value}`]);
            }
        });

        useMeta(() => {

            function safeStringify(obj) {
                const cache = new WeakSet();
                return JSON.stringify(obj, (key, value) => {
                    if (typeof value === 'object' && value !== null) {
                        if (cache.has(value)) {
                            return;
                        }
                        cache.add(value);
                    }
                    return value;
                });
            }

            let currentRout = router.currentRoute.value.path;
            if (router.currentRoute.value.name === 'Product' || router.currentRoute.value.params.city !== '') {
                currentRout = `/product/${router.currentRoute.value.params.productId}`;
            }

            return {
                title: metaTitle.value,
                meta: {
                    description: { name: 'description', content: metaDescription.value },
                    keywords: { name: 'keywords', content: metaKeywords.value },
                    og_title: { property: 'og:title', content: metaTitle.value },
                    og_type: { property: 'og:type', content: 'website' },
                    og_image: { property: 'og:image', content: product.value?.previewImage },
                    og_url: {
                        property: 'og:url',
                        content: `https://${process.env.APP_SERVICE_HOSTNAME}${router.currentRoute.value.fullPath}`,
                    },
                    og_site_name: {
                        property: 'og:site_name',
                        content: `${process.env.APP_SERVICE_HOSTNAME}`,
                    },
                    og_description: {
                        property: 'og:description',
                        content: metaDescription.value,
                    },
                },
                link: [
                    {
                        rel: 'canonical',
                        href: `https://${process.env.APP_SERVICE_HOSTNAME}` + currentRout,
                    },
                ],
                script: {
                    ldJson: {
                        type: 'application/ld+json',
                        innerHTML: safeStringify([
                            {
                                '@context': 'https://schema.org',
                                '@type': 'DrugCost',
                                'applicableLocation': {
                                    '@type': 'AdministrativeArea',
                                    'name': 'Россия',
                                },
                                'costCategory': 'Розничная цена',
                                'costCurrency': 'RUB',
                                'costOrigin': 'Данные Medicare',
                                'costPerUnit': product.value.price,
                                'drugUnit': product.value.subtitleFull,
                                'guideline': {
                                    '@type': 'MedicalGuideline',
                                    'name': MedicalGuideline.value,
                                },
                                'relevantSpecialty': {
                                    '@type': 'MedicalSpecialty',
                                    'name': product.value.category.title,
                                },
                                'url': `https://${process.env.APP_SERVICE_HOSTNAME}${router.currentRoute.value.fullPath}`,
                            },
                            {
                                '@context': 'https://schema.org/',
                                '@type': 'Product',
                                ...(product.value.reviews?.length ? {
                                    'aggregateRating': {
                                        '@type': 'AggregateRating',
                                        'ratingValue': productRating.value,
                                        'reviewCount': product.value.reviews.length,
                                    },
                                } : {}),
                                'name': productName.value,
                                'image': [
                                    product.value?.previewImage,
                                ],
                                'description': productSubtitleFull.value,
                                'sku': product.value.qDs,
                                'mpn': productBarcode.value,
                                'brand': {
                                    '@type': 'Brand',
                                    'name': productManufacturer.value,
                                },
                                'offers': {
                                    '@type': 'Offer',
                                    'url': `https://${process.env.APP_SERVICE_HOSTNAME}${router.currentRoute.value.fullPath}`,
                                    'priceCurrency': 'RUB',
                                    'itemCondition': 'https://schema.org/UsedCondition',
                                    'availability': 'https://schema.org/InStock',
                                    'seller': {
                                        '@type': 'Organization',
                                        'name': 'Аптечная сеть Таблеточка',
                                    },
                                    'shippingDetails': {
                                        '@type': 'OfferShippingDetails',
                                        'deliveryTime': {
                                            '@type': 'ShippingDeliveryTime',
                                            'businessDays': {
                                                '@type': 'OpeningHoursSpecification',
                                                'dayOfWeek': [
                                                    'https://schema.org/Monday',
                                                    'https://schema.org/Tuesday',
                                                    'https://schema.org/Wednesday',
                                                    'https://schema.org/Thursday',
                                                    'https://schema.org/Friday',
                                                    'https://schema.org/Saturday',
                                                    'https://schema.org/Sunday',
                                                ],
                                            },
                                        },
                                    },
                                    'price': product.value.price,
                                },
                            },
                            {
                                '@context': 'https://schema.org/',
                                '@type': 'BreadcrumbList',
                                'itemListElement': [{
                                    '@type': 'ListItem',
                                    'position': '1',
                                    'item': `https://${process.env.APP_SERVICE_HOSTNAME}`,
                                    'name': 'Главная',
                                }, {
                                    '@type': 'ListItem',
                                    'position': '2',
                                    'item': `https://${process.env.APP_SERVICE_HOSTNAME}${router.currentRoute.value.fullPath}`,
                                    'name': `${productName.value}`,
                                }],
                            },
                            {
                                '@context': 'https://schema.org',
                                '@type': 'BuyAction',
                                'object': {
                                    '@type': 'Product',
                                    'name': product.value.name,
                                },
                                'seller': {
                                    '@type': 'Organization',
                                    'name': 'Аптечная сеть Таблеточка',
                                },
                            },
                            {
                                '@context': 'https://schema.org',
                                '@type': 'ImageObject',
                                'author': '"E-Tabl.ru',
                                'contentUrl': product.value.previewImage,
                                'height': 600,
                                'width': 600,
                            },
                        ]),

                    },
                },
            };
        });

        return {
            q: useQuasar(),
            city,
            cityIn,
            metaCity,
            schemaPrice,
            productPrice,
            productPriceMeta,
            productName,
            productSubtitleFull,
            productSubtitleShort,
            productManufacturer,
            productBarcode,
            seoTitle,
            seoDescription,
            seoKeywords,
            product,
            productRating,
            MedicalGuideline,
        };
    },
};
</script>
